import React from 'react';

const IconGDrive = () => (
  <svg
    fill="#000000"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    width="24px"
    height="24px">
    <title>Google Drive</title>
    <path d="M 17.107422 5.0078125 L 17.107422 6.5078125 L 16.458984 6.8574219 L 15.826172 5.7910156 L 3.1953125 28.962891 A 1.50015 1.50015 0 0 0 3.1738281 30.357422 L 9.1621094 42.177734 A 1.50015 1.50015 0 0 0 10.5 43 L 36.5 43 A 1.50015 1.50015 0 0 0 37.796875 42.253906 L 44.685547 30.416016 A 1.50015 1.50015 0 0 0 45 29.5 L 45 29.470703 A 1.50015 1.50015 0 0 0 44.707031 28.583984 L 32.203125 5.7871094 A 1.50015 1.50015 0 0 0 30.888672 5.0078125 L 17.144531 5.0078125 L 17.107422 5.0078125 z M 19.619141 8.0078125 L 30 8.0078125 L 40.953125 27.972656 L 30.386719 27.986328 L 19.619141 8.0078125 z M 17.119141 9.6894531 L 22.003906 18.753906 L 10.591797 38.361328 L 6.2070312 29.705078 L 17.119141 9.6894531 z M 23.673828 21.849609 L 26.982422 27.990234 L 20.095703 27.998047 L 23.673828 21.849609 z M 40.890625 30.974609 L 35.636719 40 L 13.109375 40 L 18.347656 31 L 40.890625 30.974609 z" />
  </svg>
);

export default IconGDrive;
